<template lang="pug">
  .page-404(v-if="content")
    .page__wr
      .page-404__wr
        .page-404__left
          h1.page-404__title
            | {{h1}}
          .page-404__txt(v-html="content.txt")
          .page-404__btn-wr
            router-link.page-404__btn(to="/")
              | Главная

        .page-404__right
          .page-404__right-bg
          .page-404__right-img(:style="{ backgroundImage: `url(${content.rightImg})`}")
</template>

<script>
import EventBus from '@/eventBus';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

// @ is an alias to /src


import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';

export default {
  name: 'Page404',

  mixins: [AjaxHelpersVue],

  components: {
    SvgIcon
  },

  data() {
    return {
      content: null
    }
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('load404Page', () => {
      this.request();
    });
  },

  methods: {
    request() {
      this.req('NotFoundPage:getNotFoundPage', {url: '*'}, res => {

        if(this.checkProperty(res.content)) {
          this.content = res.content;
        }
        EventBus.$emit('pageDone');
      }, 'page404');
    }
  }
}
</script>
